export default __webpack_public_path__ + "static/media/MW.22514c08.svg";